<template>
  <el-container :class="`container-box ${!showTab ? 'no-tabs' : ''}`">
    <div v-if="isInTelegramWebApp && showTelegramWebApp" class="telegramWebApp-header">
      <HHeader :isTg="true" />
    </div>
    <el-header
      v-if="!hideHeader.includes($route.path)"
      :style="computedHeight"
      class="h5-user_header"
      :class="{
        'no-border': isHow === 0,
        'telegramWebApp-top': isInTelegramWebApp && showTelegramWebApp,
        isInTelegramWebApp: isInTelegramWebApp,
      }"
    >
      <div class="header-box">
        <!-- <i
          class="el-icon-arrow-left"
          :style="{
            'font-weight': 'bold',
            opacity: white.includes($route.path) ? 0 : 1,
          }"
          @click="goBanlk"
        ></i> -->
        <img
          class="arrow-left"
          @click="goBanlk"
          :src="require(`@/assets/exchange/fanhui_btn.png`)"
          alt="return"
          :style="{
            opacity: hideBack ? 0 : 1,
          }"
        />

        <div class="head-title">
          {{ title }}
          <span v-if="$route.name === 'hWalletDetail'" class="el-icon-question" @click="onShowInfoModal"></span>
        </div>

        <div class="right-wrap">
          <emailIcon v-if="showEmailIcon" />
          <span
            v-if="!noService.includes($route.path)"
            class="kefu"
            v-exposure="{ eid: `101_27_0_0` }"
            :data-id="`101_27_0_0`"
            @click="onLinkService"
          >
            <img src="@/assets/user/kefu_icon.png" alt />
          </span>
          <span v-if="noService.includes($route.path)"></span>
        </div>
      </div>
    </el-header>
    <!-- h5菜单  -->
    <div
      v-if="getIsMobile"
      @click="h5NavClose"
      class="h5-menu-bar"
      :class="[
        menuIsShow ? 'menuopen' : '',
        topNavigationTemplate && topNavigationTemplate.menuPosition === 2 ? 'memu-right' : '',
      ]"
    >
      <div class="menu-box" @click.stop=""><navMenu key="navMenu2" /></div>
    </div>
    <el-container
      class="main-box"
      :class="[
        hideHeader.includes($route.path) ? 'noPaddingTop' : '',
        isInTelegramWebApp ? 'isInTelegramWebApp' : '',
        isInTelegramWebApp && showTelegramWebApp ? 'telegramWebApp-container' : '',
      ]"
    >
      <el-container>
        <el-main id="mainBox">
          <div class="center-box">
            <div class="view-box" :class="getIsMobile ? 'mobile' : ''">
              <transition :name="transitionName">
                <!-- <router-view class="child-view" /> -->
                <div style="height: 100%">
                  <!-- <keep-alive>
                    <router-view v-if="$route.meta.keepAlive" class="child-view"></router-view>
                  </keep-alive>
                  <router-view v-if="!$route.meta.keepAlive" class="child-view"></router-view> -->
                  <!-- <keep-alive :include="[...$store.state.keepAlivePage, ...cacheKeys1]" :max="10"> -->
                  <router-view></router-view>
                  <!-- </keep-alive> -->
                </div>
              </transition>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </el-container>
</template>
<script lang="js">
import navMenu from "./sidebar/navMenu.vue";
import { mapGetters, mapActions } from "vuex";
// import { debounce } from "@/lobby_common/utils/index.js";
import { cacheKeys } from '@/lobby_common/utils/commonEnum.js'
import HHeader from "./header/h-header.vue";
import emailIcon from "@/lobby_common/mixins_components/emailIcon/index.vue";
export default {
  name: "LayoutBox",
  components: {
    // HFooter,
    navMenu,
    HHeader,
    emailIcon
  },
  data() {
    return {
      drawerToggle: false,
      white: ["/userCenter", '/user/hTask'],
      hideHeader: ['/hEvents'],
      levelList: null,
      whiteList: ["/userCenter"],
      noService: ['/user/hCustomerService'],
      transitionName: 'slide-left',
      // showTab: true,
      mHeight: 520,
      telegramWebAppWhite: ["/userCenter", "/hEvents"],
      // showTelegramWebApp: false,
    };
  },
  watch: {
    '$route': {
      handler(to, from) {
        const toDepth = to.path.split('/').length
        const fromDepth = from.path.split('/').length
        this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left';
      },
    }
  },
  computed: {
    ...mapGetters(["menuIsShow", "getIsMobile", "sidebarWidth"]),
    showTab() {
      if (['/userCenter'].includes(this.$route.path)) {
        return true;
      }
      return false;
      // if (['/user/hGameRecord', '/user/hWalletRecord'].includes(this.$route.path)) {
      //   return false;
      // }
      // return true;
    },
    showEmailIcon() {
      if (['/userCenter'].includes(this.$route.path)) {
        return true;
      }
      return false;
    },
    hideBack() {
      return this.white.includes(this.$route.path) || this.isTgApp
    },
    showTelegramWebApp() {
      // const u = navigator.userAgent;
      // const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; // 安卓机！
      return this.telegramWebAppWhite.includes(this.$route.path);
    },
    topNavigationTemplate() {
      return this.$store.getters.getPacketConfig?.topNavigationTemplate?.h5 || null;
    },
    cacheKeys1() {
      return cacheKeys.map(key => key + '1')
    },
    title() {
      const arr = ['/hpolicy/trading', '/hpolicy/user', '/hpolicy/privacy', '/hpolicy/service']
      if (arr.includes(this.$route.path)) {
        const obj = {
          trading: 'HomePage_BTM_transactiondescription',
          user: 'HomePage_BTM_legalstatement',
          privacy: 'HomePage_BTM_privetpolicy',
          service: 'HomePage_BTM_serviceterm'
        }
        return this.$t(`Datalang.${obj[this.$route.params?.type]}`);
      }
      if (this.$route.meta.title === 'Datalang.Wallet_BTM_details') {
        return '';
      }
      // console.log(this.$route, 'this.$route====')
      return this.$t(this.$route.meta.title);
    },
    isHow() {
      return this.whiteList.includes(this.$route.path) ? 45 : 45;
    },
    computedHeight() {
      let height;

      if (this.isInTelegramWebApp) {
        if (this.showTelegramWebApp) {
          height = this.$px2rem(45);
        } else {
          height = `calc(${this.$px2rem(45)} + var(--tg-content-safe-area-inset-top, 0px) + var(--tg-safe-area-inset-top, 0px))`;
        }
      } else {
        height = this.$px2rem(45);
      }
      return {
        height
      };
    }
    // menuItems() {
    //   let items = [
    //     { icon: "mdi-face", title: "Register", route: "/register" },
    //     { icon: "mdi-lock-open", title: "Login", route: "/login" },
    //   ];
    //   if (this.userIsAuthenticated) {
    //     items = [
    //       { icon: "mdi-forum", title: "Create a Chat", route: "/create" },
    //       { icon: "mdi-chat", title: "Chat List", route: "/discover" },
    //     ];
    //   }
    //   return items;
    // },
    // userIsAuthenticated() {
    //   return null;
    // this.$store.getters.user !== null &&
    // this.$store.getters.user !== undefined
    // },
    // onlineUsers() {
    //   return this.$store.getters.onlineUsers;
    // },
  },
  created() {
    // this.commonSySize();
    // this.resizeHandler = debounce(() => {
    //   this.commonSySize();
    // }, 300);
    // window.addEventListener("resize", this.resizeHandler);
  },
  methods: {
    ...mapActions(["setMenuBar"]),
    h5NavClose() {
      this.setMenuBar(false);
    },
    onShowInfoModal() {
      this.$isPopShow({
        show: true,
        views: "coinRate",
        data: {
          title: this.$t('Datalang.Wallet_BTM_switchwalletdescription'),
        },
      });
    },
    commonSySize() {
      const idTag = document.body;
      if (idTag?.offsetWidth >= 768) {
        // this.$router.push("/user/accountInfo");
      }

      // const hei = this.showTab ? (45 + 70 - 20) : 45
      // 20 底部菜单栏有个小凸起
      // this.mHeight = window.innerHeight - hei;
    },
    goBanlk() {
      // console.log(this.$route.path, 'this.$route.path====')
      if (this.white.includes(this.$route.path)) return;
      const url = window.location.href
      if (url.includes('/hactivityDetail')) {
        this.$router.push("/hEvents?tab=2");
        return
      }
      if (url.includes('/hReward')) {
        // 第一次弹出 拉新助力提现框，不返回；第二次返回
        const isGoOutRewardFirst = sessionStorage.getItem('isGoOutRewardFirst') || ''
        if (!isGoOutRewardFirst) {
          this.$Bus.$emit("updateUserReward", { showWithdraw: true });
          sessionStorage.setItem('isGoOutRewardFirst', '1')
          return;
        } else {
          sessionStorage.removeItem('isGoOutRewardFirst')
        }
      }
      console.log(this.$route.path, 'this.$route.path====')
      if (this.$route.path === '/video') {
        this.$router.push('/home'); // 返回首页
      } else {
      // 判断是否有历史记录
        if (window.history.length > 1) {
          this.$router.go(-1); // 返回上一级
        } else {
          this.$router.push('/home'); // 返回首页
        }
      }

      // this.$router.go(-1);
    },
    onLinkService() {
      this.$eventPost("customer_service_click");
      this.$eventPost("click", {
        eid: `101_27_0_0`,
        time: Date.now(),
      });
      this.$router.push("/user/hCustomerService");
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeHandler);
  },
};
</script>
<style lang="scss" scoped>
.container-box {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  // padding-bottom: 70px;
}

.main-box {
  // height: calc(100vh - 70px - 45px);
  padding-top: 45px;
  padding-bottom: 70px;
  padding-bottom: calc(constant(safe-area-inset-bottom) + 70px); /* 兼容 iOS < 11.2 */
  padding-bottom: calc(env(safe-area-inset-bottom) + 70px); /* 兼容 iOS >= 11.2 */
  &.isInTelegramWebApp {
    padding-top: calc(45px + var(--tg-content-safe-area-inset-top, 0px) + var(--tg-safe-area-inset-top, 0px));
  }
  &.noPaddingTop {
    padding-top: 0px;
  }
  &.telegramWebApp-container {
    padding-top: calc(95px + var(--tg-safe-area-inset-top, 0px));
  }
  &.noPaddingTop.telegramWebApp-container {
    padding-top: calc(50px + var(--tg-safe-area-inset-top, 0px));
  }
}

.no-tabs {
  margin-bottom: 0;

  .main-box {
    // height: calc(100vh - 0px - 45px);
    padding-bottom: calc(constant(safe-area-inset-bottom)); /* 兼容 iOS < 11.2 */
    padding-bottom: calc(env(safe-area-inset-bottom)); /* 兼容 iOS >= 11.2 */
  }
}

.el-header,
.el-footer {
  overflow: hidden;
}

.no-border {
  border-bottom: none !important;
}
.telegramWebApp-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: var(--background-200);
  padding-top: calc(var(--tg-safe-area-inset-top, 0px));
  z-index: 999;
}
.h5-user_header {
  position: fixed;
  top: 0;
  // top: calc(var(--tg-safe-area-inset-top, 0px));
  left: 0;
  width: 100%;
  padding: 0 15px;
  z-index: 1000;
  box-sizing: border-box;
  color: var(--font-color-200);
  background: var(--background-200);
  box-shadow: var(--boxShadow-700);
  z-index: 9;

  &.isInTelegramWebApp {
    padding-top: calc(var(--tg-content-safe-area-inset-top, 0px) + var(--tg-safe-area-inset-top, 0px));
  }

  &.head-in {
    animation: slide-in 0.6s cubic-bezier(0.55, 0, 0.1, 1) forwards;
  }

  &.head-out {
    animation: slide-out 0.6s cubic-bezier(0.55, 0, 0.1, 1) forwards;
  }
  &.telegramWebApp-top {
    // top: 50px;
    top: calc(50px + var(--tg-safe-area-inset-top, 0px));
    padding-top: 0px;
  }
}

@keyframes slide-in {
  0% {
    opacity: 0;
    -webkit-transform: translate(30px, 0);
    transform: translate(30px, 0);
  }

  100% {
    opacity: 1;
    -webkit-transform: translate(0, 0);
    transform: translate(0, 0);
  }
}

@keyframes slide-out {
  0% {
    opacity: 1;
    -webkit-transform: translate(0, 0);
    transform: translate(0, 0);
  }

  100% {
    -webkit-transform: translate(30px, 0);
    transform: translate(30px, 0);
  }
}

.el-header {
  line-height: 45px;
}

.el-footer {
  padding: 0 6px;
}

.el-aside {
  line-height: 32px;
  background-color: transparent;
  color: var(--font-color-100);
  border-right: 1px solid var(--border-color-100);
  overflow: hidden;
  overflow-y: scroll;
}

.el-main {
  padding: 0px 0;
  overflow: hidden;
  overflow-y: scroll;
}

.center-box {
  display: block;
  width: 100%;
  height: 100%;
  max-width: 750px;
  margin: 0 auto;
  overflow: hide;
  zoom: 1;
  background: var(--background-100);

  .view-box {
    display: block;
    width: 100%;
    height: 100%;
    min-height: 500px;

    &.mobile {
      background: var(--background-1300);
      min-height: auto;
    }
  }
}

.header-box {
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  &.telegramWebApp {
    // box-shadow: none;
    width: 58%;
    margin: 0 auto;
  }

  // .el-icon-arrow-left {
  //   font-weight: bold;
  //   position: relative;

  //   &::after {
  //     content: "";
  //     position: absolute;
  //     left: 50%;
  //     top: 50%;
  //     width: 250%;
  //     height: 200%;
  //     transform: translateX(-50%) translateY(-50%);
  //   }
  // }
  .arrow-left {
    width: 22px;
    height: 22px;
    cursor: pointer;
  }

  .head-title {
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    height: 45px;
    line-height: 45px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
  }

  .kefu {
    margin-left: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #0c186c;
    padding: 3px;
    border-radius: 50%;

    img {
      width: 28px;
    }
  }
  .right-wrap {
    display: flex;
  }
}
</style>
